import { Dispatch } from 'redux';

import { ActionType } from '../action-types';
import { GetStatsCountDataAction } from '../actions';
import { fbnApi as API } from '../../../../../../../utils/api-handler';

/************************************/
/*                                  */
/* GET STATS COUNT DATA API CREATOR */
/*                                  */
/************************************/

type GetStatsCountDataRequestDataType = {
  userId: string;
  token: string;
};

export const getStatsCountData = ({
  userId,
  token
}: GetStatsCountDataRequestDataType) => {
  return async (dispatch: Dispatch<GetStatsCountDataAction>) => {
    dispatch({
      type: ActionType.GET_STATS_COUNT_DATA_REQUEST
    });

    try {
      const response = await API(
        {
          data: '',
          method: 'GET',
          url: `/admin/analytics/${userId}`
        },
        token
      );

      dispatch({
        type: ActionType.GET_STATS_COUNT_DATA_SUCCESS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: ActionType.GET_STATS_COUNT_DATA_ERROR,
        payload: {
          data: [],
          statusCode: 400,
          message: 'Something went wrong. Please Try Again Later.'
        }
      });
    }
  };
};
